import React from "react";
import {ResultTray} from "../../../services/interface/trays/result-tray";
import {AccountCircleTwoTone} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {formatDateHoursString} from "../../../utils/daysOptions";
import Evaluation from "./Evaluation";

interface Props {
    result?: ResultTray
}
export default function InfoPerson({result}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    function getValue(value: string | undefined | Date | number) {
        if (value instanceof Date) {
            return(formatDateHoursString(value))
        }
        return value
    }

    function TextInfo({label, value}: {label: string, value?: string | undefined | Date | number}) {
        return(
            <div className={'flex flex-col'}>
                <span className={'text-empColorSecondary'}>{`${label}:`}</span>
                <span className={'text-white ml-auto'}>{getValue(value)}</span>
            </div>
        )
    }

    return(
        <div className={`bg-headerMenus rounded-[4px] flex flex-col sm:flex-row items-center p-1 gap-3`}>
            <div className={'w-full sm:w-auto pl-3 flex flex-col gap-3'}>
                <div className={'flex flex-row items-center gap-2 border border-b-secondary border-transparent pb-1'}>
                    <AccountCircleTwoTone className={'text-white min-w-[35px] min-h-[35px]'}/>
                    <div className={'flex flex-col'}>
                        <h2 className={'text-white font-light'}>{result?.names}</h2>
                        <h3 className={'text-white font-light'}>{result?.identification}</h3>
                    </div>
                </div>
                <div className={'flex flex-col sm:flex-row gap-7'}>
                    <TextInfo label={t('creation-date')} value={result?.creationDate}/>
                    <TextInfo label={t('mail')} value={result?.mail}/>
                    <TextInfo label={t('result')} value={result?.id}/>
                </div>
            </div>
            <Evaluation/>
        </div>
    )
}
